import React from 'react'
import '../styles/Navbar.css';

const Navbar = () => {
  return (
    <div>
      <div className="top-navbar">
        <div className="inputBoc-Container">
          <input type="text" className="nav-Searchbar" />
        </div>
        <div className="navList-container">
          <ul className="navList">
            <li className="navItems">
              <span>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.3"
                    d="M17.8074 20.9675C17.337 20.4976 17.337 19.7357 17.8074 19.2658C18.2779 18.7958 19.0406 18.7958 19.5111 19.2658L24.3298 24.0791C24.8002 24.549 24.8002 25.311 24.3298 25.7809C23.8593 26.2508 23.0965 26.2508 22.6261 25.7809L17.8074 20.9675Z"
                    fill="#6993FF"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.40771 14.1C5.40771 18.7521 9.18315 22.5233 13.8404 22.5233C18.4976 22.5233 22.273 18.7521 22.273 14.1C22.273 9.44791 18.4976 5.67666 13.8404 5.67666C9.18315 5.67666 5.40771 9.44791 5.40771 14.1ZM19.8637 14.1C19.8637 17.4229 17.167 20.1167 13.8404 20.1167C10.5138 20.1167 7.81705 17.4229 7.81705 14.1C7.81705 10.7771 10.5138 8.08333 13.8404 8.08333C17.167 8.08333 19.8637 10.7771 19.8637 14.1Z"
                    fill="#6993FF"
                  />
                </svg>
              </span>
            </li>
            <li className="navItems">
              <span>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.3"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.46253 13.9336C2.87642 14.519 2.87642 15.4683 3.46253 16.0537L6.45101 19.0389C7.03712 19.6244 7.98739 19.6244 8.5735 19.0389L11.562 16.0537C12.1481 15.4683 12.1481 14.519 11.562 13.9336L8.5735 10.9484C7.98739 10.363 7.03712 10.363 6.451 10.9484L3.46253 13.9336ZM17.9185 13.9336C17.3324 14.519 17.3324 15.4683 17.9185 16.0537L20.907 19.0389C21.4931 19.6244 22.4434 19.6244 23.0295 19.0389L26.018 16.0537C26.6041 15.4683 26.6041 14.519 26.018 13.9336L23.0295 10.9484C22.4434 10.363 21.4931 10.363 20.907 10.9484L17.9185 13.9336Z"
                    fill="#6993FF"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6906 6.71358C10.1044 7.29905 10.1044 8.24827 10.6906 8.83373L13.679 11.8189C14.2651 12.4044 15.2154 12.4044 15.8015 11.8189L18.79 8.83373C19.3761 8.24827 19.3761 7.29905 18.79 6.71358L15.8015 3.72842C15.2154 3.14296 14.2651 3.14296 13.679 3.72842L10.6906 6.71358ZM10.6906 21.1536C10.1044 21.739 10.1044 22.6883 10.6906 23.2737L13.679 26.2589C14.2651 26.8444 15.2154 26.8444 15.8015 26.2589L18.79 23.2737C19.3761 22.6883 19.3761 21.739 18.79 21.1536L15.8015 18.1684C15.2154 17.583 14.2651 17.583 13.679 18.1684L10.6906 21.1536Z"
                    fill="#6993FF"
                  />
                </svg>
              </span>
            </li>
            <li className="navItems">
              <span>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    opacity="0.3"
                    x="16.2603"
                    y="5.67666"
                    width="3.614"
                    height="19.2533"
                    rx="1.807"
                    fill="#6993FF"
                  />
                  <rect
                    x="10.2368"
                    y="11.6933"
                    width="3.614"
                    height="13.2367"
                    rx="1.807"
                    fill="#6993FF"
                  />
                  <rect
                    x="22.2837"
                    y="14.1"
                    width="3.614"
                    height="10.83"
                    rx="1.807"
                    fill="#6993FF"
                  />
                  <rect
                    x="4.21338"
                    y="16.5067"
                    width="3.614"
                    height="8.42333"
                    rx="1.807"
                    fill="#6993FF"
                  />
                </svg>
              </span>
            </li>
            <li className="navItems">
              <span>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.3"
                    d="M15.061 6.353L9.96316 12.4637C9.53723 12.9742 8.77761 13.0432 8.2665 12.6178C7.75538 12.1923 7.68633 11.4335 8.11225 10.923L14.1356 3.70297C14.6172 3.12567 15.5049 3.12567 15.9865 3.70297L22.0098 10.923C22.4357 11.4335 22.3667 12.1923 21.8556 12.6178C21.3445 13.0432 20.5848 12.9742 20.1589 12.4637L15.061 6.353Z"
                    fill="#6993FF"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.82119 11.6933H25.3005C25.9658 11.6933 26.5052 12.2321 26.5052 12.8967C26.5052 13.0555 26.4737 13.2128 26.4125 13.3595L22.0109 23.9118C21.4497 25.257 20.1338 26.1333 18.6749 26.1333H11.4469C9.98788 26.1333 8.672 25.257 8.11086 23.9118L3.70919 13.3595C3.4533 12.746 3.74372 12.0415 4.35786 11.7859C4.50467 11.7248 4.66214 11.6933 4.82119 11.6933ZM15.0609 21.32C16.3915 21.32 17.4702 20.2425 17.4702 18.9133C17.4702 17.5842 16.3915 16.5067 15.0609 16.5067C13.7302 16.5067 12.6515 17.5842 12.6515 18.9133C12.6515 20.2425 13.7302 21.32 15.0609 21.32Z"
                    fill="#6993FF"
                  />
                </svg>
              </span>
            </li>
            <li className="navItems">
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.3"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.2712 2.17666C11.2712 1.34823 11.9428 0.676659 12.7712 0.676659H18.2039C19.0323 0.676659 19.7039 1.34823 19.7039 2.17666V7.59999C19.7039 8.42842 19.0323 9.09999 18.2039 9.09999H12.7712C11.9428 9.09999 11.2712 8.42842 11.2712 7.59999V2.17666ZM0.429199 13.0067C0.429199 12.1782 1.10077 11.5067 1.9292 11.5067H7.36187C8.19029 11.5067 8.86187 12.1782 8.86187 13.0067V18.43C8.86187 19.2584 8.19029 19.93 7.36187 19.93H1.9292C1.10077 19.93 0.429199 19.2584 0.429199 18.43V13.0067ZM12.7712 11.5067C11.9428 11.5067 11.2712 12.1782 11.2712 13.0067V18.43C11.2712 19.2584 11.9428 19.93 12.7712 19.93H18.2039C19.0323 19.93 19.7039 19.2584 19.7039 18.43V13.0067C19.7039 12.1782 19.0323 11.5067 18.2039 11.5067H12.7712Z"
                    fill="#6993FF"
                  />
                </svg>
              </span>
            </li>
          </ul>
        </div>
        <p className="a-name">Nick Thomas</p>
        <div className="name-letter">
          <span id="fL">N</span>
        </div>
      </div>
      <div className="sec-navbar">
        <div className="btn-container1">
          <button id="dashBtn">Dashboard</button>
          <button id="addNewBtn">Add New</button>
        </div>
        <div className="btn-container2">
          <button id="tBtn">Today</button>
          <button id="mBtn">Month</button>
          <button id="yBtn">Year</button>
          <button id="aBtn">Actions</button>
        </div>
        <div className="plusContainer">
          <span id='plusIcon'>
          <svg
            width="37"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.3"
              d="M9.56315 3.665H21.7063C22.0607 3.665 22.4037 3.79049 22.6744 4.01921L30.328 10.4857C30.6653 10.7707 30.8599 11.1899 30.8599 11.6315V30.8654C30.8599 33.5586 30.8291 33.7483 28.0634 33.7483H9.56315C6.79739 33.7483 6.7666 33.5586 6.7666 30.8654V6.54799C6.7666 3.85471 6.79739 3.665 9.56315 3.665Z"
              fill="#0ABB87"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.3073 21.715L14.2956 21.715C13.4639 21.715 12.7898 21.0416 12.7898 20.2108C12.7898 19.3801 13.4639 18.7067 14.2956 18.7067L17.3073 18.7067L17.3073 15.6983C17.3073 14.8676 17.9814 14.1942 18.8131 14.1942C19.6447 14.1942 20.3189 14.8676 20.3189 15.6983L20.3189 18.7067L23.3306 18.7067C24.1622 18.7067 24.8364 19.3801 24.8364 20.2108C24.8364 21.0416 24.1622 21.715 23.3306 21.715L20.3189 21.715L20.3189 24.7233C20.3189 25.5541 19.6447 26.2275 18.8131 26.2275C17.9814 26.2275 17.3073 25.5541 17.3073 24.7233L17.3073 21.715Z"
              fill="#0ABB87"
            />
          </svg>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Navbar